import type { VendorConfigPlugin } from "../../portals/messagemedia/vendorConfig/loadVendorConfigPlugin";

export type CookieConsentValue = "unset" | `${boolean}`;

export const isCookieConsentUnset = (
  consent: Record<string, CookieConsentValue>
) =>
  Object.values(consent).some(
    (onesaasConsentValue) => onesaasConsentValue === "unset"
  );

export const shouldHandleConsent = (
  vendorPlugin: VendorConfigPlugin
): boolean => !!vendorPlugin?.isBrandSE();
